import * as ko from 'knockout';

declare var DobryKantor: any;

export class OpinionsDoradcyFirmyComponent {
    index: ko.Observable<number>;
    timer: any;

    executeTimer() {
        this.timer = setTimeout(() => {
            this.index(this.index() % 2 + 1);
            this.executeTimer();
        }, 10000);
    }

    constructor() {
        this.index = ko.observable(1);
        this.executeTimer();
    }

    isCurrentIndex(index: any) {
        return this.index() === index;
    }
}
